import React from 'react';
import { withRouter, Redirect } from 'react-router-dom';

import 'assets/scss/landingPage.css';
import {
  TRIAL_SIGNUP_ROUTES,
  RENEW_SUBSCRIPTION_ROUTES,
} from 'constants/Routes';
import SignUpWrapper from 'containers/SignUpWrapper';
import { isProPlan, isPlanActive } from 'utils/plansHelper';
import { getUserData, getContactDetails } from 'constants/localStorageManager';

const SelectPlanWrapper = ({ location, renew, children }) => {
  const route = renew
    ? RENEW_SUBSCRIPTION_ROUTES.SELECT_PLANS
    : TRIAL_SIGNUP_ROUTES.SELECT_PLANS;

  if (renew && isProPlan() && isPlanActive()) {
    return <Redirect to="/" />;
  }
  const { first_name: firstName } = getContactDetails() || getUserData() || {};
  return (
    <SignUpWrapper step={route} currentStep={location.pathname} renew={renew}>
      <div className="col-md-10 offset-md-1">
        <h3 className="mt-5 mb-2 text-dark" style={{ fontWeight: 600 }}>
          Hi {firstName}, Welcome to Soono
        </h3>
        <p className="text-dark">
          Pick which plan to get started. You can downgrade at anytime
        </p>
        <div className="row mt-5 mb-5">{children}</div>
      </div>
    </SignUpWrapper>
  );
};

export default withRouter(SelectPlanWrapper);



// WEBPACK FOOTER //
// ./src/components/transactions/SelectPlanWrapper.js